module.exports = "<app-banner heading=\"Login\" description=\"Discover an unprecedented resolution increase in your velocity model\"></app-banner>\n<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-8 col-xs-12\" style=\"padding:20px;\">\n      <button class=\"btn btn-primary btn-margin\"\n              *ngIf=\"auth.isAuthenticated()\"\n              (click)=\"auth.logout()\">\n        Log Out\n      </button>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main